import "scripts/templates/product.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.product");
